import React, { useState } from "react";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import classnames from "classnames";
import { gettext } from "web/script/modules/django-i18n";
import styles from "./step-guide.css";

interface StepGuideItem {
    title: string;
    paragraphs: string[];
}

interface StepGuideItemProps {
    value: StepGuideItem;
    numeral: number;
    visible: boolean;
}

export function StepGuideItem({ value, numeral, visible }: StepGuideItemProps): JSX.Element {
    return (
        <li className={classnames(styles.stepGuideItem, { [styles.visible]: visible })}>
            <span
                className={classnames(styles.numeral, {
                    [styles.one]: numeral === 0,
                    [styles.two]: numeral === 1,
                    [styles.three]: numeral === 2,
                })}
            />
            <h4 className={styles.title}>{value.title}</h4>
            {value.paragraphs.map((paragraph) => {
                return (
                    <p key={paragraph} className={styles.paragraph}>
                        {paragraph}
                    </p>
                );
            })}
        </li>
    );
}

interface StepGuideProps {
    title?: string;
    items: StepGuideItem[];
    sign_up_url: string;
}

function StepGuide({ title, items, sign_up_url: signUpUrl }: StepGuideProps): JSX.Element {
    const [currentIndex, setCurrentIndex] = useState(0);
    const last = items.length - 1;

    function next(): void {
        const nextIndex = currentIndex === last ? 0 : currentIndex + 1;
        setCurrentIndex(nextIndex);
    }

    function previous(): void {
        const previousIndex = currentIndex === 0 ? last : currentIndex - 1;
        setCurrentIndex(previousIndex);
    }

    return (
        <div className={styles.stepGuideWrapper}>
            {title && <h3 className={styles.heading}>{title}</h3>}
            <button
                aria-label={gettext("paginated_carousel.prev_btn_txt")} // previous
                type="button"
                onClick={previous}
                className={styles.previous}
            >
                <SVGIcon name="chevron" rotate={-180} />
            </button>
            <button
                aria-label={gettext("paginated_carousel.next_btn_txt")} // next
                type="button"
                onClick={next}
                className={styles.next}
            >
                <SVGIcon name="chevron" />
            </button>
            <ol className={styles.stepGuideList}>
                {items.map((value, index) => (
                    <StepGuideItem
                        key={value.title}
                        value={value}
                        numeral={index}
                        visible={index === currentIndex}
                    />
                ))}
            </ol>
            <a href={signUpUrl} className={styles.signUpLink}>
                {gettext("homepage.module_value_props_sign_up_button") // Sign  up
                }
            </a>
        </div>
    );
}

export default StepGuide;
